export default "__VITE_ASSET__Fx_UnDhp__"